"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILoseWeight = void 0;
var ILoseWeight;
(function (ILoseWeight) {
    ILoseWeight["Healthconcerns"] = "healthconcerns";
    ILoseWeight["Other"] = "other";
    ILoseWeight["Lifeevent"] = "lifeevent";
    ILoseWeight["Lookandfeelbetter"] = "lookandfeelbetter";
})(ILoseWeight || (exports.ILoseWeight = ILoseWeight = {}));
//# sourceMappingURL=lose-weight.js.map